module.exports = __webpack_public_path__ + "img/yellowbelt-map.eb2be2b6.png";